import { render, staticRenderFns } from "./subgrupo.vue?vue&type=template&id=3aa66514&"
import script from "./subgrupo.vue?vue&type=script&lang=js&"
export * from "./subgrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports